import React, { memo, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Checkbox, FormControlLabel, Grid } from '@mui/material';

import { AdvancedSearchFieldsCmpProps } from 'ui/components/Page/PageWithAdvancedSearch';
import { getVendors, Vendor } from 'services/vendors';
import { Autocomplete } from 'ui/components/Autocomplete/Autocomplete';

const TaxRatesAdvancedSearch: React.FC<AdvancedSearchFieldsCmpProps> = (
  props
) => {
  const { setFormValues, formValues } = props;

  const { items: vendors } = useSelector(getVendors);

  const selectedVendor = useMemo(
    () => vendors.find((v) => v.id === formValues.agencyId) || null,
    [formValues.agencyId, vendors]
  );

  const handleVendorChange = useCallback(
    (e: any, vendor: Vendor | null) => {
      setFormValues({ ...formValues, agencyId: vendor ? vendor.id : null });
    },
    [setFormValues, formValues]
  );

  const handleShowDeletedChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      setFormValues({ ...formValues, deleted: checked ? 'true' : null });
    },
    [formValues, setFormValues]
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Autocomplete
          label="Vendor"
          options={vendors}
          value={selectedVendor}
          placeholder="Select vendor"
          getOptionLabel={(v: Vendor) => v.name || ''}
          onChange={handleVendorChange}
          dataQa="select-vendor"
        />
      </Grid>
      <Grid item xs={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={!!formValues.deleted}
              onChange={handleShowDeletedChange}
              color="primary"
              data-qa="show-default"
            />
          }
          label="Show Deleted"
        />
      </Grid>
    </Grid>
  );
};

export default memo(TaxRatesAdvancedSearch);
